import {
  GENERAL_SEARCH,
  ORDERS_SEARCH,
  CLIENTS_SEARCH,
  COMMUNICATIONS_SEARCH,
  NOTES_SEARCH,
  MESSAGES_SEARCH,
  SEARCH_ORDERS_SUCCESS,
  SEARCH_CLIENTS_SUCCESS,
  SEARCH_CLIENTS_FAILURE,
  SEARCH_ORDERS_FAILURE,
  SEARCH_COMMUNICATIONS_SUCCESS,
  SEARCH_COMMUNICATIONS_FAILURE,
  SEARCH_NOTES_SUCCESS,
  SEARCH_NOTES_FAILURE,
  SEARCH_MESSAGES_SUCCESS,
  SEARCH_MESSAGES_FAILURE,
  CLEAR_GENERAL_SEARCH,
} from '../actions/search';

const initialState = {
  orderPage: 1,
  clientPage: 1,
  communicationPage: 1,
  notePage: 1,
  messagePage: 1,

  clients: {
    items: [],
    total: 0,
  },
  orders: {
    items: [],
    total: 0,
  },
  communications: {
    items: [],
    total: 0,
  },
  notes: {
    items: [],
    total: 0,
  },
  messages: {
    items: [],
    total: 0,
  },

  isSearchingOrders: false,
  isSearchingClients: false,
  isSearchingCommunication: false,
  isSearchingNotes: false,
  isSearchingMessages: false,

  clientsError: '',
  ordersError: '',
  communicationsError: '',
  notesError: '',
  messagesError: '',

  hasNextPage: true,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GENERAL_SEARCH: {
      return {
        ...state,
        clients: initialState.clients,
        orders: initialState.orders,
        communications: initialState.communications,
        notes: initialState.notes,
        messages: initialState.messages,
        orderPage: 1,
        clientPage: 1,
        communicationPage: 1,
        notePage: 1,
        isSearchingOrders: true,
        isSearchingClients: true,
        isSearchingCommunication: true,
        isSearchingNotes: true,
        isSearchingMessages: true,
      };
    }
    case CLEAR_GENERAL_SEARCH: {
      return {
        ...state,
        clients: initialState.clients,
        orders: initialState.orders,
        communications: initialState.communications,
        notes: initialState.notes,
        messages: initialState.messages,
        orderPage: 1,
        clientPage: 1,
        communicationPage: 1,
        notePage: 1,
        isSearchingOrders: false,
        isSearchingClients: false,
        isSearchingCommunication: false,
        isSearchingNotes: false,
        isSearchingMessages: false,
      };
    }
    case ORDERS_SEARCH: {
      return {
        ...state,
        orderPage: state.orderPage + 1,
        isSearchingOrders: true,
      };
    }
    case CLIENTS_SEARCH: {
      return {
        ...state,
        clientPage: state.clientPage + 1,
        isSearchingClients: true,
      };
    }
    case COMMUNICATIONS_SEARCH: {
      return {
        ...state,
        communicationPage: state.communicationPage + 1,
        isSearchingCommunication: true,
      };
    }
    case NOTES_SEARCH: {
      return {
        ...state,
        notePage: state.notePage + 1,
        isSearchingNotes: true,
      };
    }
    case MESSAGES_SEARCH: {
      return {
        ...state,
        messagePage: state.messagePage + 1,
        isSearchingMessages: true,
      };
    }
    case SEARCH_ORDERS_SUCCESS: {
      const { orders, meta } = action.payload;
      return {
        ...state,
        isSearchingOrders: false,
        hasNextPage: state.orderPage < meta.total_pages,
        orders: {
          total: meta.total,
          items: [...state.orders.items, ...orders],
        },
      };
    }
    case SEARCH_ORDERS_FAILURE: {
      return {
        ...state,
        isSearchingOrders: false,
        ordersError: action.error,
      };
    }
    case SEARCH_CLIENTS_SUCCESS: {
      const { persons, meta } = action.payload;
      return {
        ...state,
        isSearchingClients: false,
        hasNextPage: state.clientPage < meta.total_pages,
        clients: {
          total: meta.total,
          items: [...state.clients.items, ...persons],
        },
      };
    }
    case SEARCH_CLIENTS_FAILURE: {
      return {
        ...state,
        isSearchingClients: false,
        clientsError: action.error,
      };
    }
    case SEARCH_COMMUNICATIONS_SUCCESS: {
      const { mails, meta } = action.payload;
      return {
        ...state,
        isSearchingCommunication: false,
        hasNextPage: state.communicationPage < meta.total_pages,
        communications: {
          total: meta.total,
          items: [...state.communications.items, ...mails],
        },
      };
    }
    case SEARCH_COMMUNICATIONS_FAILURE: {
      return {
        ...state,
        isSearchingCommunication: false,
        communicationsError: action.error,
      };
    }
    case SEARCH_NOTES_SUCCESS: {
      const { notes, meta } = action.payload;
      return {
        ...state,
        isSearchingNotes: false,
        hasNextPage: state.notePage < meta.total_pages,
        notes: {
          total: meta.total,
          items: [...state.notes.items, ...notes],
        },
      };
    }
    case SEARCH_NOTES_FAILURE: {
      return {
        ...state,
        isSearchingNotes: false,
        notesError: action.error,
      };
    }
    case SEARCH_MESSAGES_SUCCESS: {
      const { messages, meta } = action.payload;
      return {
        ...state,
        isSearchingMessages: false,
        hasNextPage: state.messagePage < meta.total_pages,
        messages: {
          total: meta.total,
          items: [...state.messages.items, ...messages],
        },
      };
    }
    case SEARCH_MESSAGES_FAILURE: {
      return {
        ...state,
        isSearchingMessages: false,
        messagesError: action.error,
      };
    }
    default:
      return state;
  }
};
